import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NHADialogModule, NHAFormsModule, NHATabGroupModule, NHAUserProfileMenuModule } from '@nha/components';
import { NHAActionBarModule } from '@nha/components/action-bar/action-bar.module';
import { NHAPipesModule } from '@nha/pipes';

const sharedComponents = [];

@NgModule({
	declarations: [sharedComponents],
	exports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,

		// NHA
		NHADialogModule,
		NHAFormsModule,
		NHAPipesModule,
		NHAUserProfileMenuModule,
		NHATabGroupModule,
		NHAActionBarModule
	],
	providers: [{ provide: 'AT_MANAGER_GRID_SELECTORS_KEY', useValue: 'at-manager-grid-selectors' }]
})
export class ATSharedModule {}
